import styleDialog from '../styles/dialog.shadow.less';
import styleInput from '../styles/input.shadow.less';

import styleContactEmailSettings from './contact-email-settings.shadow.less';

import {showFeedbackMsg} from '../../js/helper/feedbackMsg';

import {regexEmail2} from '../../js/helper/regex';

class ContactEmailSettings extends HTMLElement {
    constructor(){
        super();
        this.root = this.attachShadow({ mode: 'open' });
        this.applyStyle(styleDialog);
        this.applyStyle(styleInput);
        // 如果要做為基底元件，可選擇不要注入基底樣式，只注入 reset style
        this.applyStyle(styleContactEmailSettings);

        // 初始化 shadow DOM 結構 (不含內容)
        this.init();

        // 必須手動綁定 this，否則不會正確的指向 this (web component 實體)
        // 語法說明：
        // this._handleResize = this._handleResize.bind(this);
    }

    // === 注入樣式 === //
    applyStyle(style){
        const elem = document.createElement('style');
        elem.textContent = style;
        this.root.appendChild(elem);
    }

    // === 初始化，在 constructor 中執行 === //
    init(){
        const buttonText = window.t('common.button');

        const container = document.createElement('div');
        container.className = 'container';

        const sampleText = window.t('managers.bindTo.email.placeholder');

        container.innerHTML =
        `<div class="overlay"></div>
        <div class="dialog">
            <div class="title"></div>
            <div class="hint hide"></div>
            <div class="contentwpr">
                <input type="email" id="emailInput" required placeholder="${sampleText}" />
            </div>
            <div class="btnwpr">
                <div class="btn cancel">
                    <svg><use xlink:="" href="/assets/sprites/sprites_solid.svg#times"></use></svg>${buttonText.cancel}
                </div>
                <div class="btn confirm">
                    <svg><use xlink:="" href="/assets/sprites/sprites_solid.svg#check"></use></svg>${buttonText.confirm}
                </div>
            </div>
        </div>`;

        this.root.append(container);
    }

    // *** 以下四種內建的生命週期方法，都是 Callback 結尾 *** //

    // === 內建生命週期: 當元件被插入到 DOM 中時調用 === //
    // 與畫面實際出現、互動相關的行為，都應該放在 connectedCallback
    // 包括 UI 行為、事件綁定、資料載入、動畫等
    connectedCallback(){
        const container = this.root.querySelector('.container');

        container.addEventListener('click', (e) => {

            const target = e.target;

            // 取消
            if(target.closest('.cancel')){
                container.classList.remove('visible');
                // this.dispatchCustomEvent('select-multi-cancel', '取消');
            }

            // 確認
            if(target.closest('.confirm')){

                let value = container.querySelector('#emailInput').value;
                value = value.trim();

                if(value.length > 0){
                    // 驗證格式
                    const pass = regexEmail2.test(value);
                    // 如果有輸入文字，就需要符合格式
                    if(!pass){
                        // 請輸入正確格式
                        showFeedbackMsg(window.t('common.hint.invalidFormat'), 'fail');
                        return;
                    }
                }

                // 但也允許輸入空字串，可用來清空已設定的內容

                this.dispatchCustomEvent('contact-email-settings-confirm', {
                    host: this.root.host,
                    data: value,
                });
            }

        });

        // overlay 的 transition 時間比較久，所以用 overlay 當基準
        const overlay = container.querySelector('.overlay');

        overlay.addEventListener('transitionend', (e) => {
            // 在 CSS transition-property 中有指定到的屬性都會觸發 ex: opacity,visibility...
            // 為了避免重複觸發，此處以 visibility 作為代表
            if(e.propertyName === 'visibility' && !container.classList.contains('visible')){
                this.dispatchCustomEvent('contact-email-settings-transitionend', {
                    host: this.root.host
                });
            }
        });
    }

    // === 內建生命週期: 當元件被移出 DOM 時調用 === //
    // 移除方法，在父層用 .remove() 從 DOM 中移除 <contact-email-settings>
    // 如果有不是綁在 component 本身的東西
    // 在卸載時務必手動移除，以免造成 memory leak，例如以下幾種
    // 1. 綁定在 window, document, body 上的事件監聽器
    // 2. setInterval, setTimeout, WebSocket, MutationObserver 等
    disconnectedCallback(){
        // 綁定在 shadoe DOM 的事件監聽器會被自動移除，不用手動移除
        // 除此之外都需要手動移除
        // window.removeEventListener('resize', this._handleResize);
    }

    // === 內建生命週期: 當元件的屬性 (attributes) 變動時調用 === //
    // changed, added, removed, or replaced
    // 只有用 static get observedAttributes 列出的屬性才會被追蹤
    attributeChangedCallback(name, oldValue, newValue){
        if(name === 'visibility' && newValue === 'hidden'){
            // 從外部關閉
            this.root.querySelector('.container').classList.remove('visible');
        }
    }

    // 注意：如果要啟用 attributeChangedCallback()，需要搭配 getter
    // 用 static get 定義 observedAttributes
    // (瀏覽器會自動讀取 component.observedAttributes 值，來決定要監聽哪些屬性變化)
    // 所以需要指定哪些屬性需要監聽，當這些屬性改變時會觸發 attributeChangedCallback
    static get observedAttributes() {
        return ['visibility'];
    }

    // === 內建生命週期: 元件被移到另一個 document 時（如 iframe 之間) === //
    // 很少用，一般可略過
    adoptedCallback(){

    }

    // *** 以下為自訂方法 *** //

    // seeter 從外部接收資料
    // 當資料改變時可做相應的處理，例如更新內容等
    /** @param {(Object|Array)} [data=null] - 傳入資料 */
    set setData(data = null){
        this.render(data);
    }

    // === 根據資料產生內容 === //
    render(data){
        if(!data){
            return;
        }

        const container = this.root.querySelector('.container');

        let titleIcon = '';
        if(data.icon){
            titleIcon =
            `<svg><use xlink:href="/assets/sprites/sprites_solid.svg#${data.icon}"></use></svg>`;
        }

        // dialog 標題
        container.querySelector('.title').innerHTML = `${titleIcon}${data.title}`;

        // dialog hint
        const hintwpr = container.querySelector('.hint');
        if(data.hint){
            let content = '<ul>';
            data.hint.forEach((item) => {
                content += `<li>${item}</li>`;
            });
            content += '</ul>';

            hintwpr.innerHTML = content;

            hintwpr.classList.remove('hide');
            if(data.hintStyle){
                hintwpr.classList.add(data.hintStyle);
            }
        } else {
            hintwpr.classList.add('hide');
        }

        if(data.value && data.value.length > 0){
            container.querySelector('#emailInput').value = data.value;
        }

        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                container.classList.add('visible');
            });
        });
    }

    // === 向外傳遞資料 === //
    // 利用 dispatchEvent 觸發自訂的事件，向上傳遞資料給父層
    dispatchCustomEvent(name, detail = {}) {
        this.dispatchEvent(new CustomEvent(name, {
            detail: detail,
            bubbles: true,
            composed: true
        }));
    }

    // === window.resize === //
    // _handleResize(){
        // 需要注意，以這個綁定在 window 上的事件處理器為例
        // 如果在 constructor 中不手動綁定 this
        // this._handleResize = this._handleResize.bind(this);
        // 那麼這邊預設指向的 this 會變成 window（或 undefined，如果是 strict mode）
    // }

}


customElements.define('contact-email-settings', ContactEmailSettings);